// ----------------------------------------------------------------------

export default function Chip(theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 600,
          fontSize: '0.8125rem',
          letterSpacing: 0,
        },
        sizeSmall: {
          height: 24,
          borderRadius: 12,
          fontSize: '0.75rem',
          padding: '0 4px',
        },
        outlined: {
          borderColor: theme.palette.divider,
          backgroundColor: '#FFFFFF',
        },
        filled: {
          backgroundColor: theme.palette.grey[200],
          color: theme.palette.text.primary,
        },
        colorPrimary: {
          backgroundColor: theme.palette.primary.lighter,
          color: theme.palette.primary.dark,
        },
        colorSuccess: {
          backgroundColor: theme.palette.success.lighter,
          color: theme.palette.success.dark,
        },
        colorWarning: {
          backgroundColor: theme.palette.warning.lighter,
          color: theme.palette.warning.dark,
        },
        colorError: {
          backgroundColor: theme.palette.error.lighter,
          color: theme.palette.error.dark,
        },
      },
    },
  };
}
